import Cookies from 'js-cookie'

import { CookieKeys } from '../../../enums/cookieKeys'

export const buildEditorBackButtonUrl = (url?: string, cookieKey?: CookieKeys): string | undefined => {
  if (!url) {
    return
  }

  const query = cookieKey ? Cookies.get(cookieKey) || '' : ''

  return `${url}${query}`
}
